import React from 'react';
import {
  Card,
  CardBody,
  Heading,
  VStack,
  Text,
  Divider
} from '@chakra-ui/react';
import { INPUT_FIELD_TYPE } from '@components/DynamicFormField/constant';
import { Field } from './components';

export const GoogleRatesCard = ({ data, isEditMode, onChange }) => {
  return (
    <Card bg="backGround" borderColor="brand.500" borderWidth="2px" shadow="xl">
      <CardBody>
        <VStack alignItems="stretch" gap={1}>
          <Heading size="md" color="colorPrimary">Google Rates</Heading>
          <Text fontSize="xs" color="gray.400">Configure Google rate settings</Text>

          <Divider borderColor="whiteAlpha.300" />

          <Field
            field={{
              name: 'maxAllowedDeviationFromAverage',
              label: 'Max Allowed Deviation From Average (%)',
              fieldType: INPUT_FIELD_TYPE.INPUT,
              inputType: 'number'
            }}
            value={data.maxAllowedDeviationFromAverage != null ? (data.maxAllowedDeviationFromAverage * 100) : ''}
            editable={false}
            onChange={(e) => {
              const val = e.target.value;
              const decimalVal = val === '' ? 0 : Number(val) / 100;
              onChange('googleRates', 'maxAllowedDeviationFromAverage', decimalVal);
            }}
          />

          <Field
            field={{
              name: 'averageRatesTimeSpanInMinutes',
              label: 'Average Rates Time Span (minutes)',
              fieldType: INPUT_FIELD_TYPE.INPUT,
              inputType: 'number'
            }}
            value={data.averageRatesTimeSpanInMinutes ?? ''}
            editable={false}
            onChange={(e) => {
              const val = e.target.value;
              onChange('googleRates', 'averageRatesTimeSpanInMinutes', val === '' ? 0 : val);
            }}
          />

          <Field
            field={{
              name: 'stalenessThresholdInSeconds',
              label: 'Staleness Threshold (seconds)',
              fieldType: INPUT_FIELD_TYPE.INPUT,
              inputType: 'number'
            }}
            value={data.stalenessThresholdInSeconds ?? ''}
            editable={false}
            onChange={(e) => {
              const val = e.target.value;
              onChange('googleRates', 'stalenessThresholdInSeconds', val === '' ? 0 : val);
            }}
          />

          <Field
            field={{
              name: 'stalenessCheckEnabled',
              label: 'Staleness Check Enabled',
              fieldType: INPUT_FIELD_TYPE.SWITCH
            }}
            value={data.stalenessCheckEnabled ?? false}
            editable={false}
            onChange={(e) =>
              onChange('googleRates', 'stalenessCheckEnabled', e.target.checked)
            }
          />
        </VStack>
      </CardBody>
    </Card>
  );
};
